import { PaginationActions } from '@/components/decision-tree/hooks';
import { Button } from '@cmpsr/components';
import { FC } from 'react';
import { type IDontKnowButtonProps } from './types';

export const IDontKnowButton: FC<IDontKnowButtonProps> = ({ submitIDKAnswer, paginationDispatch }) => {
  const handleChange = async () => {
    const response = await submitIDKAnswer();
    if (!response) return;
    paginationDispatch({ type: PaginationActions.NextSurveyItem, payload: response });
  };

  return (
    <Button data-testid="btn-idk" onClick={handleChange} variant="link" size="s" color="text-link-secondary-default">
      Skip for now
    </Button>
  );
};
